export default __webpack_public_path__ + "static/media/logoBPWhorizontal.00a5ea2f.png";